import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import { meta } from "../../src/landingPage/datasets/meta";
import { KYC } from "../../src/landingPage/views/Usecases/KYC/KYC";

const KycPage = () => {
  return (
    <>
      <NextHead
        currentPath="/use-cases/kyc-workflow-automation"
        title={meta.usecases.kyc.title}
        description={meta.usecases.kyc.description}
      />
      <KYC />
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default KycPage;
